import script from "./EventHeading.vue?vue&type=script&setup=true&lang=ts"
export * from "./EventHeading.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__